import React from 'react'
import { CheckItem, HazardLevel } from '@/types'

interface CheckItemCardProps {
  item: CheckItem
  checked: boolean
  onToggle: (item: CheckItem) => void
  onDelete?: (item: CheckItem) => void
}

export const CheckItemCard: React.FC<CheckItemCardProps> = ({
  item,
  checked,
  onToggle,
  onDelete,
}) => {
  const isMajor = item.hazardLevel === HazardLevel.MAJOR

  return (
    <div
      className={`flex items-start p-4 border-b border-gray-100 transition-all cursor-pointer ${
        checked
          ? isMajor
            ? 'bg-red-50'
            : 'bg-orange-50'
          : 'bg-white'
      }`}
      onClick={() => onToggle(item)}
    >
      {/* 复选框 */}
      <div
        className={`w-5 h-5 rounded border-2 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0 ${
          checked
            ? isMajor
              ? 'bg-red-600 border-red-600'
              : 'bg-orange-500 border-orange-500'
            : 'border-gray-300'
        }`}
      >
        {checked && (
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
            <path
              d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
              fill="white"
            />
          </svg>
        )}
      </div>

      {/* 项目名称 */}
      <div className="flex-1">
        <div className="flex items-center">
          <div className="text-base text-gray-800 leading-relaxed">
            {item.name}
          </div>
          {item.isCustom && (
            <div className="ml-2 px-2 py-0.5 bg-blue-500 text-white text-xs rounded">
              自定义
            </div>
          )}
        </div>
        {item.isCustom && (
          <div className="text-sm text-gray-500 mt-1">
            {isMajor ? '重大隐患' : '一般隐患'}
          </div>
        )}
      </div>

      {/* 删除按钮 */}
      {item.isCustom && onDelete && (
        <div
          className="text-gray-400 hover:text-red-500 ml-2"
          onClick={(e) => {
            e.stopPropagation()
            onDelete(item)
          }}
        >
          🗑️
        </div>
      )}
    </div>
  )
}
